import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const OtherSettingsSkeleton = memo(() => {
  return (
    <SettingCardSkeleton
      titleWidth={140}
      controls={["buttons", "buttons", "input"]}
      showFooter
    />
  );
});

OtherSettingsSkeleton.displayName = "OtherSettingsSkeleton";

export default OtherSettingsSkeleton;
